import * as Icons from 'components/Utils/Icons'
import { selectors as UsersSelectors } from 'data/users'
import { selectors as OrganizationsSelectors } from 'data/organizations'

export const PROFILE = {
  id: 'profile',
  title: 'Personal settings',
  icon: Icons.ArobaseIcon,
  shouldDisplay(state) {
    return true
  },
}
export const INFORMATIONS = {
  id: 'informations',
  title: 'Team settings',
  icon: Icons.CogIcon,
  shouldDisplay(state) {
    const organizationIsFree = OrganizationsSelectors.isFree(state)
    return (
      organizationIsFree ||
      UsersSelectors.canCurrentUserManageOrganization(state)
    )
  },
}
export const USERS = {
  id: 'users',
  title: 'Members',
  icon: Icons.PeopleIcon,
  prefixOrganization: true,
  shouldDisplay(state) {
    const userIsGuest = UsersSelectors.isCurrentUserGuest(state)
    return !userIsGuest
  },
}
export const INVITATIONS = {
  id: 'invitations',
  title: 'Invitations',
  icon: Icons.MailIcon,
  shouldDisplay(state) {
    return UsersSelectors.canCurrentUserInviteMembers(state)
  },
}

export const AUTHENTICATION = {
  id: 'authentication',
  title: 'Authentication',
  icon: Icons.LockIcon,
  shouldDisplay(state) {
    const userIsGuest = UsersSelectors.isCurrentUserGuest(state)
    if (userIsGuest) {
      return false
    }
    const organizationIsFree = OrganizationsSelectors.isFree(state)
    return (
      organizationIsFree ||
      UsersSelectors.canCurrentUserManageOrganization(state)
    )
  },
}
export const CHANNELS = {
  id: 'channels',
  title: 'Channels',
  icon: Icons.ChannelClosedIcon,
  shouldDisplay(state) {
    return UsersSelectors.canCurrentUserManageChannels(state)
  },
}

export const USER_GROUPS = {
  id: 'userGroups',
  title: 'Groups',
  icon: Icons.UserGroupIcon,
  shouldDisplay(state) {
    const userIsGuest = UsersSelectors.isCurrentUserGuest(state)
    return !userIsGuest
  },
}

export const BILLING = {
  id: 'billing',
  title: 'Billing',
  icon: Icons.BillingIcon,
  shouldDisplay(state) {
    const organizationIsFree = OrganizationsSelectors.isFree(state)
    const userIsGuest = UsersSelectors.isCurrentUserGuest(state)
    if (userIsGuest) {
      return false
    }
    return (
      organizationIsFree ||
      UsersSelectors.canCurrentUserManageOrganizationBilling(state)
    )
  },
  subTabs: [
    {
      id: 'overview',
      title: 'Overview',
      shouldDisplay() {
        return true
      },
    },
    {
      id: 'upgrade',
      title: 'Upgrade',
      shouldDisplay: UsersSelectors.hasAccessToFreeBillingViews,
    },
    {
      id: 'invoices',
      title: 'Invoices',
      shouldDisplay: UsersSelectors.hasAccessToPaidBillingViews,
    },
    {
      id: 'informations',
      title: 'Billing information',
      shouldDisplay: UsersSelectors.hasAccessToPaidBillingViews,
    },
    {
      id: 'switch',
      title: 'Your plan',
      shouldDisplay: UsersSelectors.hasAccessToPaidBillingViews,
    },
  ],
}

export const INTEGRATIONS = {
  id: 'integrations',
  title: 'Integrations',
  icon: Icons.PlugIcon,
  shouldDisplay(state) {
    return UsersSelectors.canCurrentUserManageIntegrations(state)
  },
}

export const FLAGS = {
  id: 'flags',
  title: 'Feature flags',
  icon: Icons.ActivityEmptyIcon,
  prefixOrganization: true,
  shouldDisplay(state) {
    const hasNextFlag = OrganizationsSelectors.hasFeatureFlag(state, 'next')
    const organization = OrganizationsSelectors.getOrganization(state)
    return hasNextFlag || organization.domain === 'slite'
  },
}

export const ANALYTICS = {
  id: 'analytics',
  title: 'Team insights',
  icon: Icons.AnalyticsIcon,
  shouldDisplay(state) {
    const userIsGuest = UsersSelectors.isCurrentUserGuest(state)
    if (userIsGuest) {
      return false
    }
    return true
  },
}
